export const contractsAddresses: { [key: string]: `0x${string}` } = {
  usdt: '0xa56f1E83785e79d8b4192Ed5afbC4884a00B43ea',
  apy: '0xA5156aFA7c2CaD0e3f348C79E58d03863d418bF0'
}
